module.exports = __webpack_public_path__ + "static/media/8materialypromocyjne.fed94681.png";